// Override
var GetExpandedChildHeight = function (child, parentHeight) {
    return undefined;
}

export default GetExpandedChildHeight;